import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import { useAuth } from '@clerk/react-router';
import { SignedIn } from "@clerk/clerk-react";

import Home from './Home/App.js';

import SignInPage from './authentication/signin.tsx';
import SignUpPage from './authentication/signup.tsx';

import CreatePage from './Dashboard/create'
import Dashboard from './Dashboard';
import WishlistPage from './Dashboard/wishlist';
import BirthdayDashboardPage from './Dashboard/birthday';
import BirthdayCreatePage from './Dashboard/birthday/create';
import Page from './page';
import WishlistApply from './WishlistApply';
import BirthdayView from './BirthdayView';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoaded, userId } = useAuth();

  if (!isLoaded || !userId) {
    if (
      location.pathname !== '/' &&
      location.pathname !== '/sign-up' &&
      location.pathname !== '/login' &&
      !location.pathname.startsWith('/page/') &&
      !location.pathname.startsWith('/wishlist/') &&
      !location.pathname.startsWith('/birthday/')
    ) {
      navigate('/');
    }
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/login" element={<SignInPage />} />
      <Route path="/sign-up" element={<SignUpPage />} />

      <Route
        path="/dashboard/create"
        element={
          <SignedIn>
            <CreatePage />
          </SignedIn>
        }
      />
      <Route
        path="/dashboard"
        element={
          <SignedIn>
            <Dashboard />
          </SignedIn>
        }
      />
      <Route
        path="/dashboard/wishlist"
        element={
          <SignedIn>
            <WishlistPage />
          </SignedIn>
        }
      />
      <Route
        path="/dashboard/birthday"
        element={
          <SignedIn>
            <BirthdayDashboardPage />
          </SignedIn>
        }
      />
      <Route
        path="/dashboard/birthday/create"
        element={
          <SignedIn>
            <BirthdayCreatePage />
          </SignedIn>
        }
      />
      <Route
        path="/page/:pageId"
        element={
          <Page />
        }
      />
      <Route path="/wishlist/:wishlistId" element={<WishlistApply />} />
      <Route path="/birthday/:birthdayId" element={<BirthdayView />} />
    </Routes>
  );
}

export default App;
